// Pixall integration specs can be found here: https://pixall-qa-api.prod.analytics.dealer.com/docs#search-facets

const pixallAttrMap = {
	// type <string> or <string>[]
	compositeType: 'searchFacetVehicleTypes',
	bodyStyle: 'searchFacetBodyStyles',
	normalBodyStyle: 'searchFacetBodyStyles',
	fuelType: 'searchFacetFuelTypes',
	normalFuelType: 'searchFacetFuelTypes',
	interiorColor: 'searchFacetInteriorColors',
	normalInteriorColor: 'searchFacetInteriorColors',
	exteriorColor: 'searchFacetExteriorColors',
	normalExteriorColor: 'searchFacetExteriorColors',
	trim: 'searchFacetTrim',

	// type <string>
	make: 'searchFacetMake',
	model: 'searchFacetModel',
	geoRadius: 'searchFacetDistance',
	geoZip: 'searchFacetZipCode',

	// type <string> with range
	odometer: 'searchFacetMileage',
	cityFuelEconomy: 'searchFacetMpgCity',
	highwayFuelEconomy: 'searchFacetMpgHighway',

	// compound facets
	internetPrice: ['searchFacetMinPrice', 'searchFacetMaxPrice'],
	year: ['searchFacetMinYear', 'searchFacetMaxYear']
};

const getValueAsArray = (values = []) => values.map(({ value }) => value);
const handleRangedValues = (values = []) =>
	values.reduce(
		(rangeValues, { value }) => rangeValues.concat(value.split('-')),
		[]
	);
const getMinMax = (arr = []) => [
	Math.min.apply(null, arr),
	Math.max.apply(null, arr)
];

export const getPixallParams = (appliedFilters, pageId, pageLabel) => {
	const data = {
		type: 'event',
		eventType: 'ajaxPageView',
		label: pageLabel,
		pageType: 'vlp',
		pageId
	};

	appliedFilters.forEach(facet => {
		const { id, values } = facet;
		const pixallAttr = pixallAttrMap[facet.id];

		if (!pixallAttr) {
			return;
		}

		switch (id) {
			case 'make':
			case 'model':
			case 'geoRadius':
			case 'geoZip':
				data[pixallAttr] = String(getValueAsArray(values));
				break;
			case 'year': {
				const [minVal, maxVal] = getMinMax(getValueAsArray(values));
				data[pixallAttr[0]] = String(minVal);
				data[pixallAttr[1]] = String(maxVal);
				break;
			}
			case 'odometer':
			case 'cityFuelEconomy':
			case 'highwayFuelEconomy': {
				const [, maxVal] = getMinMax(handleRangedValues(values));
				data[pixallAttr] = String(maxVal);
				break;
			}
			case 'internetPrice': {
				const [minVal, maxVal] = getMinMax(handleRangedValues(values));
				data[pixallAttr[0]] = String(minVal);
				data[pixallAttr[1]] = String(maxVal);
				break;
			}
			default:
				data[pixallAttr] = getValueAsArray(values);
		}
	});

	return data;
};

export const sendPixallData = (appliedFilters, pageId, pageLabel) => {
	if (!window._pxam || typeof window._pxam.push !== 'function') {
		window.DDC.log(
			'ws-inv-data: could not send PixAll event - missing library methods'
		);
		return;
	}
	const data = getPixallParams(appliedFilters, pageId, pageLabel);
	window._pxam.push(data);
};
